import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccueilComponent } from './pages/accueil/accueil.component';
import { TemoignageResolver } from '../../core/resolvers/temoignages.resolver';
import { AccueilSlidesResolver } from '../../core/resolvers/accueil-slides.resolver.';
import { NouvellesResolver } from '../../core/resolvers/nouvelles.resolver';

const routes: Routes = [
  {
    path: 'accueil',
    component: AccueilComponent,
    resolve: { slides: AccueilSlidesResolver, temoignages: TemoignageResolver, nouvelles: NouvellesResolver }
  }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [RouterModule]
})
export class AccueilRoutingModule { }
